import React, { Component } from "react";
import axios from "axios";

import closeImg from "../../images/icon-close.png";
import { BACKEND_CONFIG } from "../../config/consts";
import { RequoteConsumer } from "../../context/quote-versioning-context";
import Expander from "../../components/Expander";

import CoverageDetails from "./CoverageDetails";
import GeneralInfo from "./GeneralInfo";
import CollectionItems from "./CollectionItems";
import ActivityLog from "./ActivityLog";
import {
  showUnderwriterReviewSuccessToast,
  showSurplusUnderwriterReviewSuccessToast,
  showErrorToast,
} from "./UnderwriterReview";

class LobDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quoteActions: [],
      selectedQuoteAction: undefined,
    };

    this.updateQuoteDetails = this.updateQuoteDetails.bind(this);
    this.updateQuoteAction = this.updateQuoteAction.bind(this);
    this.removeQuoteAction = this.removeQuoteAction.bind(this);
    this.requestUWReview = this.requestUWReview.bind(this);
  }

  componentDidMount() {
    this.currentControl.scrollIntoView(true);
    let generalInfo = this.props.lobDetails.GeneralInfo;

    axios
      .get(
        `${BACKEND_CONFIG.apiUrl}/clients/${generalInfo.ClientId}/quotes/${generalInfo.PolicyQuoteId}/quote-actions`
      )
      .then(({ data }) => {
        this.setState({
          quoteActions: data,
          selectedQuoteAction: undefined,
        });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.lobDetails !== this.props.lobDetails) {
      this.currentControl.scrollIntoView(true);
    }
  }

  updateQuoteDetails(widgetId, value) {
    this.updateWidget(widgetId, value);
    this.updateQuoteAction("Requote");
  }

  updateQuoteAction(value) {
    this.setState({
      selectedQuoteAction: value,
    });
  }

  removeQuoteAction(value) {
    let actions = this.state.quoteActions;

    this.setState({
      quoteActions: [
        ...actions.filter(function (action) {
          return action.Value !== value;
        }),
      ],
    });
  }

  callUpdateQuoteAndUWValidationLabelCheck = (value) => {
    this.updateQuoteAction(value);
    this.checkSelectValueToUnhideError(value);
  };

  requestUWReview(clientId, quoteId, surplusLines) {
    axios
      .post(
        `${BACKEND_CONFIG.apiUrl}/clients/${clientId}/quotes/${quoteId}/requestunderwriterreview`
      )
      .then(({ data }) => {
        if (surplusLines) showSurplusUnderwriterReviewSuccessToast();
        else showUnderwriterReviewSuccessToast();

        this.updateQuoteAction(undefined);
        this.removeQuoteAction("RequestUWReview");
        this.props.reload();
      })
      .catch(() => {
        showErrorToast();
      });
  }

  render() {
    let lobDetails = this.props.lobDetails;
    let generalInfo = lobDetails.GeneralInfo;
    let borderClass = this.props.selectedPolicyQuoteId
      ? "selected-quote-policy-details"
      : "";

    return (
      <div
        style={{ fontFamily: "Open Sans" }}
        className={borderClass}
        ref={(section) => {
          this.currentControl = section;
        }}
      >
        <div className="four-panel">
          <div className="lob-details-header">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <span
                      style={{ paddingLeft: "10px" }}
                      className="four-panel-main-header-name"
                    >
                      {generalInfo.IsPolicy
                        ? "POLICY DETAILS"
                        : "QUOTE DETAILS"}
                    </span>
                  </td>
                  <td>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a onClick={() => this.props.hideLobDetails()}>
                      <img
                        alt="close"
                        src={closeImg}
                        className="lob-details-close-img"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <RequoteConsumer>
            {(contextState) => {
              this.updateWidget = contextState.updateWidget;
              if (contextState.showError) {
                this.props.showErrorMessage("Requote");
                contextState.showedErrorMessage();
              }

              if (contextState.reload) {
                this.props.reload();
                this.props.hideLobDetails();
                contextState.reloaded();
              }
              return (
                <div>
                  {!generalInfo.IsPolicy && (
                    <Expander
                      className="activitylog"
                      title="Activity Log"
                      icon="clock"
                      quoteId={generalInfo.PolicyQuoteId}
                      isPolicy={generalInfo.IsPolicy}
                    >
                      <ActivityLog quoteId={generalInfo.PolicyQuoteId} />
                    </Expander>
                  )}
                  <Expander
                    title={generalInfo.IsPolicy ? "Policy" : "Quote"}
                    icon="quote"
                  >
                    <div className="lob-details-body">
                      <GeneralInfo
                        generalInfo={generalInfo}
                        history={this.props.history}
                        isPolicy={generalInfo.IsPolicy}
                        viewCallback={this.props.viewCallback}
                        onApplyBindRequest={this.props.onApplyBindRequest}
                        showCarrierMessages={this.props.showCarrierMessages}
                        showRequote={contextState.showRequote}
                        showBind={contextState.showBind}
                        hasNextScreen={contextState.hasNextScreen}
                        submit={contextState.onHandleContinue}
                        requestUWReview={this.requestUWReview}
                        actions={this.actions(contextState)}
                        selectedAction={this.state.selectedQuoteAction}
                        showErrorMessage={this.props.showErrorMessage}
                        updateQuoteAction={this.updateQuoteAction}
                        removeQuoteAction={this.removeQuoteAction}
                        reload={this.props.reload}
                        hideLobDetails={this.props.hideLobDetails}
                        primaryContactInfo={this.props.primaryContactInfo}
                        reloadQuoteDetails={this.props.reloadQuoteDetails}
                      />

                      <CoverageDetails
                        coverages={lobDetails.Coverages}
                        quoteWidgetData={contextState.widgets}
                        updateQuoteDetails={this.updateQuoteDetails}
                        quoteVersioningVisible={
                          this.props.quoteVersioningVisible
                        }
                      />
                      <CollectionItems lobDetails={lobDetails} />
                      {this.showQuoteProposalLink(lobDetails) && (
                        <span className="quote-proposal-link">
                          <a
                            rel="noopener noreferrer"
                            download={
                              "Hiscox_" +
                              lobDetails.Id +
                              "quoteProposal" +
                              new Date().toLocaleDateString("en-US") +
                              ".pdf"
                            }
                            href={
                              lobDetails.Coverages.find(
                                (cov) => cov.Id === 1196001
                              )?.Value
                            }
                          >
                            Download Quote Proposal PDF
                          </a>
                        </span>
                      )}
                    </div>
                  </Expander>
                </div>
              );
            }}
          </RequoteConsumer>
        </div>
      </div>
    );
  }

  actions(contextState) {
    return this.state.quoteActions.filter(
      (a) =>
        !contextState.hasChanges ||
        (a.Value !== "Bind" && a.Value !== "RequestBind")
    );
  }

  showQuoteProposalLink(lobDetails) {
    var urlCovDet = lobDetails.Coverages.find((cov) => cov.Id === 1196001);
    if (
      urlCovDet &&
      lobDetails.GeneralInfo.CarrierId === 208 &&
      [100, 200, 500, 510, 520].includes(lobDetails.GeneralInfo.LobId)
    ) {
      return urlCovDet.Value;
    }
  }
}

export default LobDetails;
